import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';
import Select from 'react-select';

import ProductListFilter from 'lib/enums/ProductListFilter';

const UPB_MATCH_STATUS = {
  EXISTS: 'exists',
  NOT_EXISTS: 'not_exists',
};

function UPBMatchStatusFilter({ selectedValue, updateFilters }) {
  const options = [
    {
      label: 'UPB match exists',
      value: UPB_MATCH_STATUS.EXISTS,
    },
    {
      label: "UPB match doesn't exist",
      value: UPB_MATCH_STATUS.NOT_EXISTS,
    },
  ];

  return (
    <Form.Group>
      <Form.Label>UPB Matched Products</Form.Label>
      <Select
        isClearable
        options={options}
        value={options.find(val => val.value === selectedValue)}
        onChange={opt => updateFilters(ProductListFilter.UPB_MATCH_STATUS, opt?.value)}
      />
    </Form.Group>
  );
}

UPBMatchStatusFilter.propTypes = {
  selectedValue: PropTypes.string,
  updateFilters: PropTypes.func.isRequired,
};

export default UPBMatchStatusFilter;
